import { useEffect } from 'react';

export default function useMount(
  effect: (abortController?: AbortController) => any,
  dependencies?: Array<any>,
) {
  return useEffect(() => {
    const abortController = new AbortController();

    const cb = effect(abortController);

    if (abortController) {
      return () => {
        if (typeof cb == 'function') {
          cb();
        }
        abortController.abort();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies ?? []);
}
